import { ActionType, ActionTypes } from './index';
import { IAppState } from '../reducers/index';
import { SeatingOptionGroup } from '../classes/seating-option'

export interface IAppAction {
    type: ActionType;
    value?: any;
}

export function openViewFromSeatModal() {
    return { type: ActionTypes.OPEN_SEATVIEW_MODAL };
}

export function closeViewFromSeatModal() {
    return { type: ActionTypes.CLOSE_SEATVIEW_MODAL };
}

export function showLoadingScreen() {
    return { type: ActionTypes.LOADING_SCREEN, value: true };
}

export function hideLoadingScreen() {
    return { type: ActionTypes.LOADING_SCREEN, value: false };
}
// export function setPackageTicketQuantity(priceTypeQuantity: Array<any>) {
//    return { type: ActionTypes.SET_PACKAGE_TICKET_QUANTITIES, value: priceTypeQuantity }
// }